/*
 * Copyright (c) 2024 GM Global Technology Operations LLC. All rights reserved.
 * This information is confidential and proprietary to GM Global Technology
 * Operations LLC and may not be used, modified, copied or distributed.
 */

import styled from 'styled-components'

const BottomButtonsWrapper = styled.div({
  marginTop: 20,
  display: 'flex',
  gap: '0 10px',
  "> button": {
    height: 30,
  },
  alignSelf: 'center'
})

export {
  BottomButtonsWrapper
}